import { ResponsibleGaming } from '@fanduel/cpe-um-bundle/responsible-gaming/library';
import { initializeUnifiedModules } from '../unified-modules-core';

export const presentResponsiblePlaySettings = async (): Promise<void> => {
  await initializeUnifiedModules();

  await ResponsibleGaming.presentResponsiblePlaySettingsAsync(
    undefined,
    true,
    true,
  );
};

export const presentGlobalDepositLimits = async (): Promise<void> => {
  await initializeUnifiedModules();
  await ResponsibleGaming.presentGlobalDepositLimitsAsync(
    undefined,
    true,
    true,
  );
};

export const presentRealityCheckSettings = async (): Promise<void> => {
  await initializeUnifiedModules();
  await ResponsibleGaming.presentRealityCheckSettingsAsync(
    undefined,
    true,
    true,
  );
};

/**
 * Starts the periodic Reality Check flow owned by cpe-um-bundle. The bundle
 * subscribes to the account session and, on each valid session, runs an
 * interval timer that presents the "Reality Check" modal (session time +
 * amount wagered) into the CoreModalPresenter surface (<UMModals />) once the
 * region-configured interval elapses. It also resumes on session refresh and
 * stops on logout, so this only needs to be kicked off once after the unified
 * modules are initialized.
 */
export const startRealityCheck = async (): Promise<void> => {
  await initializeUnifiedModules();

  ResponsibleGaming.startRealityCheck();
};
